import { NgModule } from '@angular/core';
import { I_PAGE_VISIBILITY_SERVICE } from '../common/i-page-visibility.service';
import { PageVisibilityBrowserService } from './page-visibility.browser.service';

@NgModule({
  providers: [{ provide: I_PAGE_VISIBILITY_SERVICE, useClass: PageVisibilityBrowserService }],
})
export class PageVisibilityBrowserModule {}
